var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReleaseSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4 2.1H6.6V3.9H17.4V2.1ZM3.1 5.1H20.9V6.9H3.1V5.1ZM1.6 10C1.6 8.95066 2.45066 8.1 3.5 8.1H20.5C21.5493 8.1 22.4 8.95066 22.4 10V20C22.4 21.0493 21.5493 21.9 20.5 21.9H3.5C2.45066 21.9 1.6 21.0493 1.6 20V10ZM12.0218 11.4918L16.3623 11.2119L16.4782 13.0082L13.9 13.1744V14.1V15.9V16.6254C13.9 17.9206 12.8124 18.9 11.56 18.9H10.44C9.18755 18.9 8.1 17.9206 8.1 16.6254V16.3745C8.1 15.0793 9.18755 14.1 10.44 14.1H12.1V12.7039L12.0218 11.4918ZM12.1 15.9H10.44C10.1018 15.9 9.9 16.1514 9.9 16.3745V16.6254C9.9 16.8485 10.1018 17.1 10.44 17.1H11.56C11.8982 17.1 12.1 16.8485 12.1 16.6254V15.9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleaseSolid);
export default __webpack_public_path__ + "static/media/release-solid.1f6e45ae83b67209681a54d848b34513.svg";
export { ForwardRef as ReactComponent };